import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { loadDime, preloadDimeExperience } from './../operations';
import { logDimeEvent } from './../telemetry';
import { fetchWarmupDimeOptions } from './fetchWarmupDimeOptions';
var preloadedExperiences = [];
var scheduleWarmupTask = function (config, loadDimeOptions) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        scheduleWork(function () { return __awaiter(void 0, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadDime(loadDimeOptions)];
                    case 1:
                        status = _a.sent();
                        if (status === 1 /* DimeTaskStatus.Completed */) {
                            preloadDimeExperience(config);
                        }
                        return [2 /*return*/];
                }
            });
        }); }, IDLE_VERYLOW_PRIORITY);
        return [2 /*return*/];
    });
}); };
var warmupExperience = function (experience, launchOptions) {
    if (preloadedExperiences.indexOf(experience) !== -1) {
        return;
    }
    preloadedExperiences.push(experience);
    logDimeEvent({
        eventName: KnownInstrumentationEvents.DimeWarmup,
        dimeExperience: experience,
    });
    scheduleWarmupTask({ experiences: [experience] }, launchOptions);
};
/**
 * A small wrapper meant to be called from 'warmup' or from the hook
 */
export var warmupDimeInternal = function (experiences, warmupOptions) {
    if (!warmupOptions) {
        return;
    }
    if (warmupOptions.pwaEnabled &&
        (window === null || window === void 0 ? void 0 : window.prelaunchmode)) {
        return;
    }
    experiences.forEach(function (experience) {
        warmupExperience(experience, warmupOptions);
    });
};
export var warmup = function (experiences) { return __awaiter(void 0, void 0, void 0, function () {
    var warmupDimeOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchWarmupDimeOptions()];
            case 1:
                warmupDimeOptions = _a.sent();
                warmupDimeInternal(experiences, warmupDimeOptions);
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=warmupDime.js.map